import styled from 'styled-components'

export const Page = styled.div`
  display: flex;
  min-height: 100vh;
  background: #ebedf1;
  font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
  color: #333;
`

/* largura/expansão são controladas por style inline no componente
   (props dinâmicos do styled-components não reaplicam CSS neste dev) */
export const Sidebar = styled.aside`
  flex-grow: 0;
  flex-shrink: 0;
  background: #d7dce3;
  border-radius: 0 18px 18px 0;
  display: flex;
  flex-direction: column;
  align-items: stretch;
  padding: 18px 10px;
  gap: 8px;
  overflow: hidden;
`

export const SideItem = styled.button<{ active?: boolean }>`
  width: 100%;
  height: 48px;
  border: none;
  border-radius: 12px;
  cursor: pointer;
  display: flex;
  align-items: center;
  color: ${({ active }) => (active ? '#3f444c' : '#8a929e')};
  background: ${({ active }) => (active ? '#c4cbd5' : 'transparent')};
  white-space: nowrap;
  overflow: hidden;
  transition: background 0.15s ease, color 0.15s ease;

  &:hover {
    background: #cdd3dc;
    color: #3f444c;
  }

  svg {
    flex-shrink: 0;
  }

  .label {
    font-size: 16px;
    font-weight: 600;
    overflow: hidden;
  }
`

export const SideSpacer = styled.div`
  margin-top: auto;
`

export const Main = styled.div`
  position: relative;
  flex: 1;
  min-width: 0;
  padding: 18px 22px 32px;
  overflow-x: hidden;

  @media (max-width: 600px) {
    padding: 12px 12px 24px;
  }
`

export const LoadingOverlay = styled.div`
  position: absolute;
  inset: 0;
  z-index: 20;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(235, 237, 241, 0.6);
  backdrop-filter: blur(1px);
`

export const FiltersRow = styled.div`
  display: grid;
  grid-template-columns: repeat(4, minmax(160px, 260px));
  gap: 22px;
  margin-bottom: 16px;

  @media (max-width: 900px) {
    grid-template-columns: 1fr 1fr;
  }
  @media (max-width: 560px) {
    grid-template-columns: 1fr;
    gap: 12px;
  }
`

export const Filter = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;

  label {
    font-size: 15px;
    font-weight: 600;
    color: #4a4f57;
  }
`

/* ---- KPI cards ---- */
export const KpiRow = styled.div`
  display: grid;
  grid-template-columns: repeat(5, minmax(0, 1fr));
  gap: 14px;
  margin-bottom: 16px;

  @media (max-width: 1200px) {
    grid-template-columns: repeat(3, minmax(0, 1fr));
  }
  @media (max-width: 820px) {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
  @media (max-width: 560px) {
    gap: 10px;
  }
  @media (max-width: 420px) {
    grid-template-columns: minmax(0, 1fr);
  }
`

export const KpiCard = styled.div`
  background: #fff;
  border: 1px solid #e7e9ee;
  border-radius: 8px;
  padding: 14px 18px 16px;
  text-align: center;
  min-width: 0;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.03);

  .title {
    font-size: 17px;
    color: #6b7280;
    margin-bottom: 6px;
  }
  .value {
    font-size: 30px;
    font-weight: 700;
    line-height: 1.1;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  @media (max-width: 1400px) {
    .value { font-size: 26px; }
  }
  .value.green { color: #4caf50; }
  .value.red { color: #e53935; }
  .value.dark { color: #4a4f57; }
  .hint {
    margin-top: 6px;
    font-size: 14px;
    color: #9aa2b1;
  }

  @media (max-width: 560px) {
    padding: 12px 12px 14px;
    .title { font-size: 15px; }
    .value { font-size: 26px; }
    .hint { font-size: 12px; }
  }
`

/* ---- generic panel ---- */
export const Grid = styled.div`
  display: grid;
  grid-template-columns: minmax(0, 1fr) minmax(0, 1fr);
  align-items: stretch;
  gap: 14px;

  @media (max-width: 1000px) {
    grid-template-columns: minmax(0, 1fr);
  }
`

export const Panel = styled.div`
  background: #fff;
  border: 1px solid #e7e9ee;
  border-radius: 8px;
  padding: 14px 18px 18px;
  min-width: 0;
  display: flex;
  flex-direction: column;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.03);

  .panel-title {
    text-align: center;
    font-size: 19px;
    color: #5a6069;
    margin-bottom: 14px;
  }
`

export const PanelHead = styled.div`
  position: relative;
  margin-bottom: 14px;
  min-height: 22px;

  .icons {
    position: absolute;
    left: 0;
    top: 0;
    display: flex;
    gap: 6px;
    color: #5a6069;
  }
  .icon-btn {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 28px;
    height: 28px;
    padding: 0;
    border: 1px solid transparent;
    border-radius: 6px;
    background: transparent;
    color: #8a929e;
    cursor: pointer;
    transition: background 0.15s ease, color 0.15s ease, border-color 0.15s ease;
  }
  .icon-btn:hover {
    background: #eef1f5;
    color: #5a6069;
  }
  .icon-btn.active {
    background: #e3f1fb;
    border-color: #bfe0f5;
    color: #1f88c9;
  }
  .title {
    text-align: center;
    font-size: 19px;
    color: #5a6069;
  }
`

/* ---- horizontal bars ---- */
export const HBar = styled.div`
  display: grid;
  grid-template-columns: 150px 1fr;
  align-items: center;
  gap: 10px;
  margin-bottom: 12px;

  @media (max-width: 560px) {
    grid-template-columns: 96px 1fr;
    gap: 6px;
    .label { font-size: 12px; }
    .amount { font-size: 12px; }
  }

  .label {
    text-align: right;
    font-size: 17px;
    font-weight: 600;
    color: #4a4f57;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
  .track {
    display: flex;
    align-items: center;
    gap: 8px;
  }
  .fill {
    height: 20px;
    background: #8cc63f;
    border-radius: 2px;
  }
  .amount {
    font-size: 17px;
    font-weight: 700;
    color: #4a4f57;
    white-space: nowrap;
  }
`

export const AxisLabel = styled.div`
  writing-mode: vertical-rl;
  transform: rotate(180deg);
  align-self: center; /* centraliza verticalmente em relacao as barras */
  text-align: center;
  font-size: 17px;
  font-weight: 600;
  color: #7a828f;
`

/* ---- donut ---- */
export const DonutWrap = styled.div`
  flex: 1;
  display: flex;
  align-items: center;
  gap: 8px;

  .donut-svg {
    flex: 1;
    min-width: 0;
    display: flex;
    justify-content: center;
  }
  .donut-svg svg {
    width: 100%;
    max-width: 780px;
    height: auto;
    display: block;
    overflow: visible;
  }

  @media (max-width: 700px) {
    flex-wrap: wrap;
    justify-content: center;

    .donut-svg {
      flex: 1 1 100%;
    }
  }
`

export const DonutLegend = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  text-align: right;
  gap: 14px;
  min-width: 84px;
  padding-right: 6px;

  @media (max-width: 700px) {
    flex-flow: row wrap;
    justify-content: center;
    align-items: center;
    text-align: center;
    gap: 16px;
    width: 100%;
    padding: 8px 0 0;
  }

  .item {
    font-size: 14px;
    line-height: 1.15;
    color: #6b7280;
  }
  .item b {
    display: block;
    color: #4a4f57;
    font-size: 15px;
    font-weight: 600;
  }
`

/* ---- vertical bars ---- */
export const VBars = styled.div`
  display: flex;
  align-items: flex-end;
  justify-content: space-around;
  gap: 12px;
  flex: 1;
  min-height: 240px;
  padding: 12px 8px 4px;
  overflow: hidden;

  /* modo hora: rotulos em pe (verticais, lendo de baixo pra cima).
     letter-spacing afrouxa os digitos empilhados (senao ficam espremidos). */
  &.vertical .cap {
    writing-mode: vertical-rl;
    transform: rotate(180deg);
    font-size: 12px;
    letter-spacing: 0.6px;
    line-height: 1;
    margin-bottom: 8px;
  }

  @media (max-width: 560px) {
    gap: 8px;
  }
`

export const VBar = styled.div`
  flex: 1 1 0;
  min-width: 0;
  max-width: 130px;
  display: flex;
  flex-direction: column;
  align-items: center;
  height: 100%;
  justify-content: flex-end;

  .cap {
    font-size: 11px;
    font-weight: 700;
    color: #4a4f57;
    margin-bottom: 6px;
    white-space: nowrap;
  }
  .col {
    width: 100%;
    background: #29abe2;
    border-radius: 2px 2px 0 0;
  }
  .xlabel {
    margin-top: 8px;
    font-size: 14px;
    color: #6b7280;
    white-space: nowrap;
  }
`

/* ---- table ---- */
export const TablePanel = styled.div`
  position: relative;
  background: #fff;
  border: 1px solid #e7e9ee;
  border-radius: 8px;
  min-width: 0;
  min-height: 0;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.03);

  /* larguras fixas por coluna (corpo e rodapé alinhados) */
  & table {
    table-layout: fixed;
    width: 100%;
  }
  & table th:nth-child(1),
  & table td:nth-child(1) {
    width: 210px;
  }
  & table th:nth-child(2),
  & table td:nth-child(2),
  & table th:nth-child(3),
  & table td:nth-child(3),
  & table th:nth-child(4),
  & table td:nth-child(4) {
    width: 140px;
  }
  & table th:nth-child(5),
  & table td:nth-child(5) {
    width: 110px;
  }
`

/* scroll horizontal envolve corpo + rodapé (rolam juntos, colunas alinhadas) */
export const HScroll = styled.div`
  flex: 1;
  min-height: 0;
  display: flex;
  flex-direction: column;
  overflow-x: auto;
  overflow-y: hidden;
`

export const HInner = styled.div`
  flex: 1;
  min-height: 0;
  min-width: 740px;
  display: flex;
  flex-direction: column;
`

/* corpo rolável na vertical (o Total fica fora, fixo no rodapé do card) */
export const TableScroll = styled.div`
  flex: 1;
  min-height: 0;
  overflow-y: auto;
  overflow-x: hidden;
`

export const Table = styled.table`
  width: 100%;
  border-collapse: collapse;
  font-size: 15px;

  @media (max-width: 700px) {
    min-width: 460px;
  }

  thead th {
    position: sticky;
    top: 0;
    z-index: 2;
    background: #8a9099;
    color: #fff;
    text-align: right;
    padding: 10px 14px;
    font-weight: 700;
    white-space: nowrap;
  }
  thead th:first-child {
    text-align: left;
  }

  tbody td {
    padding: 8px 14px;
    text-align: right;
    border-bottom: 1px solid #eef0f3;
    color: #4a4f57;
  }
  tbody td:first-child {
    text-align: left;
  }

  tr.group td {
    font-weight: 700;
    background: #f7f9fb;
  }
  tr.child td:first-child {
    padding-left: 34px;
    color: #6b7280;
  }
  tr.total td {
    position: sticky;
    bottom: -2px;
    z-index: 1;
    font-weight: 700;
    background: #eef2f6;
    border-top: 2px solid #d7dde4;
  }

  .toggle {
    display: inline-flex;
    width: 18px;
    height: 18px;
    margin-right: 8px;
    vertical-align: middle;
    flex-shrink: 0;
    align-items: center;
    justify-content: center;
    border: 1px solid #b9c0ca;
    border-radius: 3px;
    cursor: pointer;
    font-size: 13px;
    line-height: 0;
    color: #6b7280;
    user-select: none;
  }
`

export const BottomGrid = styled.div`
  display: grid;
  grid-template-columns: minmax(0, 1fr) minmax(0, 1fr);
  align-items: stretch;
  gap: 14px;
  margin-top: 14px;
  height: 440px;

  @media (max-width: 1000px) {
    grid-template-columns: minmax(0, 1fr);
    height: auto;
  }
`
